import { useCallback, useReducer } from "react";

export type MembershipStepStateType = {
    filterValue: string;
    viewSelected: boolean;
};

enum MembershipStepActionType {
    FilterValueChanged = "FILTER_VALUE_CHANGED",
    ViewSelectedChanged = "VIEW_SELECTED__CHANGED",
}

type MembershipStepAction = {
    type: MembershipStepActionType.FilterValueChanged;
    filter: string;
} | {
    type: MembershipStepActionType.ViewSelectedChanged;
    enabled: boolean;
};

const initialState: MembershipStepStateType = {
    filterValue: "",
    viewSelected: false
};

function membershipStepReducer(state: MembershipStepStateType, action: MembershipStepAction): MembershipStepStateType {
    switch (action.type) {

        case MembershipStepActionType.FilterValueChanged:
            return {
                ...state,
                filterValue: action.filter
            };

        case MembershipStepActionType.ViewSelectedChanged:
            return {
                ...state,
                viewSelected: action.enabled
            };

        default:

            return state;
    }
}

export type UseMembershipStepStateType = {
    state: MembershipStepStateType;
    setFilterValue: (filterValue: string) => void;
    setViewSelected: (viewSelected: boolean) => void;
};

export function useMembershipStepState(): UseMembershipStepStateType {

    const [state, dispatch] = useReducer(membershipStepReducer, initialState);

    const setFilterValue = useCallback((filterValue: string) => dispatch({
        type: MembershipStepActionType.FilterValueChanged,
        filter: filterValue
    }), []);

    const setViewSelected = useCallback((viewSelected: boolean) => dispatch({
        type: MembershipStepActionType.ViewSelectedChanged,
        enabled: viewSelected
    }), []);

    return {
        state,
        setFilterValue,
        setViewSelected
    };
}
